/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-prototype-builtins */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, {useState, useEffect, useMemo, useCallback} from 'react';
import DOMPurify from 'dompurify';
import {withRouter} from 'react-router-dom';
import _ from 'lodash';
import localeText from '@locale';
import axios from 'axios';
import Logo from '~/assets/images/top_logo_global.png';
import {Input, Tree, Button, Pagination, Radio, Space, Tag} from '@enos/dpl';
import {setLanguage} from '~/utils/tools';
import './index.less';

const MAX_RESULT_PER_SECTION = 3;
const MAX_SUBSTRING_LIMIT = 150;

const queryURL = '/docs/api/v2/globalSearch/';
const DocGlobalSearch = ({history, match}) => {
  const query = new URLSearchParams(window.location.search).get('q');
  const project = new URLSearchParams(window.location.search).get('project');
  const source = new URLSearchParams(window.location.search).get('source');
  const version = new URLSearchParams(window.location.search).get('version');
  // const version = new URLSearchParams(window.location.search).get('version');
  let language = new URLSearchParams(window.location.search).get('language') || 'en';
  if (!(language === 'en' || language === 'en_us' || language === 'en_US' || language === 'EN_US')) {
    language = 'zh-cn';
  }
  const {
    params: {locale}
  } = match;
  setLanguage(locale);

  const [checkedKeys, setCheckedKeys] = useState([]);
  const [selectedVersion, setSelectedVersion] = useState(version);
  const [inputValue, setInputValue] = useState(query);
  const [searchQuery, setSearchQuery] = useState(query);
  const [searchResult, setSearchResult] = useState({});
  const [paginationState, setPaginationState] = useState({
    page: 1,
    page_size: 10
  });
  const [searching, setSearching] = useState(false);

  const [configmaps, setConfigmaps] = useState({
    limitGroupForSearch: {},
    productGroupForSearch: {},
    versionOptions: []
  });

  const [isBackTopShow, setIsBackTopShow] = useState(false);
  useEffect(() => {
    if (window.limitGroupForSearch && window.productGroupForSearch && window.versionOptions) {
      setConfigmaps({
        limitGroupForSearch: window.limitGroupForSearch || {},
        productGroupForSearch: window.productGroupForSearch || {},
        versionOptions: window.versionOptions || []
      });
    } else {
      // Compatible processing, some repos did not apply new themes
      const scriptConfig = document.createElement('script');
      scriptConfig.src = `/docs/config/config.js?${new Date().getTime()}`;
      const head = document.getElementsByTagName('head')[0];
      if (head) {
        head.insertAdjacentElement('beforeend', scriptConfig);
      }
      scriptConfig.onload = () => {
        setConfigmaps({
          limitGroupForSearch: window.limitGroupForSearch || {},
          productGroupForSearch: window.productGroupForSearch || {},
          versionOptions: window.versionOptions || []
        });
      };
    }
    const controlBackTopShow = () => {
      const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (currentScrollTop > 0) {
        setIsBackTopShow(true);
      } else {
        setIsBackTopShow(false);
      }
    };
    window.addEventListener('scroll', controlBackTopShow);
    return () => window.removeEventListener('scroll', controlBackTopShow);
  }, []);

  const [curTreeData, setCurTreeData] = useState({
    treeData: [],
    expandedKeys: []
  });

  const currentLimitGroup = useMemo(() => {
    if (project === 'all') {
      return configmaps?.limitGroupForSearch?.['@enos']?.filter((item) => {
        if (locale === 'zh_CN') {
          return item.endsWith('-zh');
        }
        return !item.endsWith('-zh');
      });
    }
    if (!_.isEmpty(configmaps.limitGroupForSearch)) {
      const targetLimitGroup = Object.values(configmaps.limitGroupForSearch)
        .filter((list) => list.some((l) => l.replace(/_/g, '-') === project))
        .reduce((acc, cur) => {
          acc.push(...cur.filter((item) => !acc.includes(item)));
          return acc;
        }, []);
      return targetLimitGroup.filter((item) => {
        if (locale === 'zh_CN') {
          return item.endsWith('-zh');
        }
        return !item.endsWith('-zh');
      });
    }
    return [];
  }, [JSON.stringify(configmaps.limitGroupForSearch), project, locale]);

  const [productTreeData, allKeys] = useMemo(() => {
    if (!_.isEmpty(configmaps.productGroupForSearch) && !_.isEmpty(currentLimitGroup)) {
      const allCheckKeys = [];
      let curLanProductGroup = configmaps.productGroupForSearch.zh_CN;
      if (locale === 'en') {
        curLanProductGroup = configmaps.productGroupForSearch.en_US;
      }
      const allProducts = Object.values(curLanProductGroup).reduce((arr, item) => {
        if (item?.children?.length) {
          item.children.forEach((child) => arr.push(child?.value));
        }
        return arr;
      }, []);
      const treeData = Object.keys(curLanProductGroup).map((key, index) => {
        const curGroup = curLanProductGroup[key]?.children?.filter((item) => currentLimitGroup.includes(item?.value));
        if (!curGroup.length) {
          return null;
        }
        allCheckKeys.push(`${key}_${index + 1}`);
        const children = curGroup.map(item => {
          allCheckKeys.push(item.value);
          return {title: item.title, key: item.value};
        });
        return {
          title: curLanProductGroup[key]?.title,
          key: `${key}_${index + 1}`,
          children
        };
      }).filter(Boolean).concat(
        currentLimitGroup.filter(item => !allProducts.includes(item))
          .map(item => {
            allCheckKeys.push(item);
            return {title: item, key: item};
          })
      );
      return [treeData, allCheckKeys];
    }
    return [[], []];
  }, [JSON.stringify(currentLimitGroup), JSON.stringify(configmaps.productGroupForSearch), locale]);

  useEffect(() => {
    if (productTreeData?.length) {
      setCurTreeData({
        ...curTreeData,
        treeData: productTreeData
      });
      setCheckedKeys(allKeys);
      changeQuery(allKeys, selectedVersion, searchQuery, paginationState);
    }
  }, [JSON.stringify(productTreeData)]);

  const changeQuery = (cKeys, ver, sQuery, pState) => {
    const searchParams = new URLSearchParams(history.location.search);
    searchParams.set('q', sQuery);
    searchParams.set('version', ver);
    searchParams.set('page', pState.page);
    searchParams.set('page_size', pState.page_size);
    history.push({
      search: searchParams.toString()
    });
    const formatterTreeKeys = cKeys?.filter((item) => currentLimitGroup.includes(item));
    setSearching(true);
    axios.post(queryURL, {
      page: pState.page,
      page_size: pState.page_size,
      q: sQuery,
      project: formatterTreeKeys?.length ? formatterTreeKeys?.join(',') : '',
      version: ver,
      language
    }).then((res) => {
      setSearchResult(res.data);
      const maxPage = Math.ceil(res.data?.count / pState.page_size) || 1;
      if (pState.page > maxPage) {
        setPaginationState({
          page: maxPage,
          page_size: pState.page_size
        });
      }
    }).catch(() => {
      setSearchResult({
        count: 0,
        next: null,
        previous: null,
        results: []
      });
      console.log('接口报错');
    }).finally(() => setSearching(false));
  };

  // 分页器的action
  const handleChange = (page, pageSize) => {
    changeQuery(checkedKeys, selectedVersion, searchQuery, {
      page,
      page_size: pageSize
    });
    setPaginationState({
      page,
      page_size: pageSize
    });
  };
  const handleShowSizeChange = (current, size) => {
    changeQuery(checkedKeys, selectedVersion, searchQuery, {
      page: current,
      page_size: size
    });
    setPaginationState({
      page: current,
      page_size: size
    });
  };
  // tree的action
  const treeTravel = (tree, callback) => {
    tree.forEach((item) => {
      callback(item);
      treeTravel(item.children || [], callback);
    });
  };

  const handleFilterProduct = _.debounce((treeData, v) => {
    const formatterTreeData = (trdata, value) => {
      const filterData = trdata.map((tree) => {
        if (tree.title.toLowerCase()?.includes(value.toLowerCase())) {
          return tree;
        }
        if (tree.children) {
          tree.children = formatterTreeData(tree.children, value);
        } else {
          tree.children = [];
        }
        if (tree.children.length > 0) {
          return tree;
        }
        return null;
      }).filter(Boolean);
      return filterData;
    };
    const cloneData = _.cloneDeep(treeData);
    if (!v.trim()) {
      setCurTreeData({
        ...curTreeData,
        treeData: cloneData
      });
    } else {
      const newTreeData = formatterTreeData(cloneData, v);
      const expanded = [];
      treeTravel(newTreeData, (item) => {
        if (item.children?.length) {
          expanded.push(item.key);
        }
      });
      setCurTreeData({
        expandedKeys: expanded,
        treeData: formatterTreeData(cloneData, v)
      });
    }
  }, 200);

  const getTagPath = useCallback((projectValue) => {
    let productsByLocale = configmaps.productGroupForSearch?.zh_CN || {};
    if (locale === 'en') {
      productsByLocale = configmaps.productGroupForSearch?.en_US || {};
    }
    let tagPath = projectValue;
    if (!_.isEmpty(productsByLocale)) {
      for (const key in productsByLocale) {
        if ((productsByLocale).hasOwnProperty(key)) {
          const projectIno = productsByLocale[key]?.children?.find((c) => c?.value === projectValue);
          if (projectIno) {
            tagPath = `${productsByLocale[key]?.title} > ${projectIno?.title}`;
            break;
          }
        }
      }
    }
    return tagPath;
  }, [JSON.stringify(configmaps.productGroupForSearch), locale]);
  const searchList = useMemo(() => (searchResult?.results?.length ? searchResult.results.map((result) => {
    const link = `${result.path}?highlight=${encodeURIComponent(searchQuery)}`;
    return (
      <li>
        <a
          href={DOMPurify.sanitize(link)}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(result?.highlights?.title?.length ? result.highlights.title[0] : result.title)
          }}
        />
        {result.blocks.length ? (
          result.blocks.map((block, index) => {
            let sectionContent = [`${block.content.substr(0, MAX_SUBSTRING_LIMIT)} ...`];
            if (block?.highlights?.content?.length) {
              const content = block.highlights.content;
              sectionContent = [];
              for (let k = 0; k < content.length && k < MAX_RESULT_PER_SECTION; k += 1) {
                sectionContent.push(`... ${content[k]} ...`);
              }
            }
            return (
              <>
                <div className='context'>
                  <div>
                    <a
                      href={DOMPurify.sanitize(`${result.path}?highlight=${encodeURIComponent(searchQuery)}#${block.id}`)}
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(block?.highlights?.title?.length ? block.highlights.title[0] : block.title)
                      }}
                    />
                  </div>
                  {sectionContent.map((item) => (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(item)
                      }}
                    />
                  ))}
                </div>
                {index < result.blocks.length - 1 ? (
                  <div className='rtd_search_hits_spacing' />
                ) : null}
              </>
            );
          })
        ) : null}
        <div className='tag-wrapper'>
          <Tag>{getTagPath(result.project)}</Tag>
        </div>
      </li>
    );
  }) : null), [JSON.stringify(searchResult)]);

  const selectedProductNumber = useMemo(() => {
    if (!_.isEmpty(configmaps.productGroupForSearch)) {
      let curLanProductGroup = configmaps.productGroupForSearch.zh_CN;
      if (locale === 'en') {
        curLanProductGroup = configmaps.productGroupForSearch.en_US;
      }
      const regex = new RegExp(`(${Object.keys(curLanProductGroup).join('|')})_+\\d+`);
      const selectedNumber = checkedKeys.filter((key) => !regex.test(key)).length;
      return selectedNumber;
    }
    return 0;
  }, [JSON.stringify(configmaps.productGroupForSearch), checkedKeys, locale]);
  return (
    <div className='global-search-page'>
      <div className='header'>
        <div className='logo-wrap'>
          <img className='logo' src={Logo} alt='logo' />
        </div>
      </div>
      <div className='content'>
        <div className='left'>
          <p
            className='go-back'
            onClick={() => { window.location.href = DOMPurify.sanitize(source); }}
          >
            <span className='dpl20_back_s go-back-icon' /><span>{localeText('GLOBAL_SEARCH.GO_BACK', project)}</span>
          </p>
          {/* <p className='filter-name'>{localeText('GLOBAL_SEARCH.FILTER')}</p> */}
          <hr className='hr' />
          <div className='filter-operator'>
            {productTreeData?.length ? (
              <div className='repo-filter'>
                <div className='repo-filter-title'>
                  <h3 className='title'>{localeText('GLOBAL_SEARCH.PROJECT_NAME')}</h3>
                  <div className='number'>{selectedProductNumber}</div>
                </div>
                <Input
                  placeholder={localeText('GLOBAL_SEARCH.FILTER_PRODUCE')}
                  className='filter-product'
                  style={{marginBottom: 8}}
                  prefix={(<span className='dpl20_search' />)}
                  onChange={(e) => handleFilterProduct(productTreeData, e.target.value)}
                />
                <Tree
                  checkable
                  checkedKeys={checkedKeys}
                  onCheck={(keys) => {
                    setCheckedKeys(keys);
                    changeQuery(keys, selectedVersion, searchQuery, paginationState);
                  }}
                  treeData={curTreeData.treeData}
                  expandedKeys={curTreeData.expandedKeys}
                  onExpand={(expandedKeys) => {
                    setCurTreeData({
                      ...curTreeData,
                      expandedKeys
                    });
                  }}
                />
              </div>
            ) : null}
            <div className='version-filter'>
              <h3 className='title'>{localeText('GLOBAL_SEARCH.VERSION_NAME')}</h3>
              <Radio.Group
                onChange={(e) => {
                  changeQuery(checkedKeys, e.target.value, searchQuery, paginationState);
                  setSelectedVersion(e.target.value);
                }}
                value={selectedVersion}
              >
                <Space direction='vertical'>
                  {configmaps.versionOptions.map((option) => (
                    <Radio value={option}>{option}</Radio>
                  ))}
                </Space>
              </Radio.Group>
            </div>
          </div>
        </div>
        <div className='right'>
          <div className='input-search'>
            <Input
              placeholder={localeText('GLOBAL_SEARCH.SEARCH')}
              value={inputValue}
              prefix={(<span className='dpl20_search' />)}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  changeQuery(checkedKeys, selectedVersion, inputValue, paginationState);
                  setSearchQuery(inputValue);
                }
              }}
            />
            <Button
              type='primary'
              className='search-button'
              onClick={() => {
                changeQuery(checkedKeys, selectedVersion, inputValue, paginationState);
                setSearchQuery(inputValue);
              }}
            >{localeText('GLOBAL_SEARCH.SEARCH')}
            </Button>
          </div>
          <div className='search-result'>
            {searching ? (
              <h2 style={{fontSize: '24px', fontWeight: 700}}>{localeText('GLOBAL_SEARCH.SEARCHING')}</h2>
            ) : (
              <>
                <h2 style={{fontSize: '24px', fontWeight: 700}}>{searchResult?.count ? localeText('GLOBAL_SEARCH.SEARCH_RESULT') : localeText('GLOBAL_SEARCH.SEARCH_NO_RESULT')}</h2>
                <p className='search-summary'>
                  {searchResult?.count ? localeText('GLOBAL_SEARCH.SEARCH_RESULT_DATA', searchResult?.count, query) : localeText('GLOBAL_SEARCH.SEARCH_NO_RESULT_DATA')}
                </p>
                <ul className='search'>
                  {searchList}
                </ul>
                <div className='search-pagination'>
                  <Pagination
                    defaultCurrent={1}
                    defaultPageSize={10}
                    // current={Math.min(paginationState.page, Math.ceil(searchResult.count / paginationState.page_size))}
                    current={paginationState.page}
                    pageSize={paginationState.page_size}
                    total={searchResult?.count}
                    onChange={handleChange}
                    showSizeChanger
                    hideOnSinglePage
                    onShowSizeChange={handleShowSizeChange}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <div className='copy-right'>{localeText('COMMON.TXT_COPY_RIGHT', new Date().getFullYear())}</div>
      {isBackTopShow ? (
        <div
          className='back-to-top'
          onClick={() => {
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }}
        />
      ) : null}
    </div>
  );
};

export default withRouter(DocGlobalSearch);
